import { useTranslation } from 'react-i18next';
import type { DataLoadUploadDefinition } from '../../models';
import { UploadListRow } from './UploadListRow';

interface UploadsListProps {
  uploads: DataLoadUploadDefinition[];
  onUpload: (upload: DataLoadUploadDefinition) => void;
}

export function UploadsList({ uploads, onUpload }: UploadsListProps) {
  const { t } = useTranslation('dataLoadModule');

  return (
    <div
      className="overflow-hidden rounded-lg border border-border bg-card transition-colors"
      data-testid="data-load-uploads-list"
    >
      <div className="hidden border-b border-border bg-muted/30 px-4 py-2.5 text-xs font-medium uppercase tracking-wide text-muted-foreground sm:grid sm:grid-cols-[1fr_auto] sm:gap-3">
        <span>{t('list.headerName')}</span>
        <span className="text-right">{t('list.headerAction')}</span>
      </div>

      {uploads.map((upload, index) => (
        <UploadListRow key={upload.id} upload={upload} isLast={index === uploads.length - 1} onUpload={onUpload} />
      ))}
    </div>
  );
}
